export default {
  heroLine1: 'Ultimate',
  heroLine2: "Gamer's",
  heroLine3: 'Haven',
  browseCatalog: 'Browse catalog',
  featuredTitle: 'Featured this week',
  viewMore: 'View more',
  platformsTitle: 'Platforms',
  howTitle: 'How PlayStock works',
  step1Title: 'Pick your game',
  step1Body: 'Browse our curated selection of verified digital titles.',
  step2Title: 'Pay in EUR with your wallet',
  step2Body: 'Secure checkout using your preferred European payment method.',
  step3Title: 'Get your key — instantly',
  step3Body: 'No waiting. Your activation code is delivered the moment payment clears.',
  emptyTitle: 'No listings yet',
  emptyFailed: "Couldn't reach the catalog API. Start the backend stack, then refresh.",
  emptyBefore: 'The catalog is empty. Add your ',
  emptyKey: 'Kinguin sandbox API key',
  emptyAfter: ' to ',
  emptyAfter2: ' and run a sync.',
};
